import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0079',
    ecrans: ['00-2']
});
